// extracted by mini-css-extract-plugin
export var active = "_j9-2";
export var recordingDot = "_j9-1";
export var recordingIndicator = "_j9-0";